export const WRAPMODE = {
    none: 0,
    word: 1,
    char: 2,
    character: 2,
    mix: 3
}